import {useApi as useApiBase} from '../../nuxt-base/composables/useApi.js';
import {traceSsrApi} from '../utils/cmsSsrDiagnostics.mjs';
import {hash} from 'ohash';

export function useApi(url, fetchOptions = {}, options = {}) {
	const trace = import.meta.server ? useRequestEvent()?.context.cmsSsrTrace : null;
	return trace ? traceSsrApi(trace, url, () => useApiTransport(url, fetchOptions, options)) : useApiTransport(url, fetchOptions, options);
}

function useApiTransport(url, fetchOptions, options) {
	const request = options?.requestOptions;
	if (!request) return useApiBase(url, fetchOptions, options);
	const transport = {
		...(request?.signal ? {signal: request.signal} : {}),
		...(request?.timeout !== undefined ? {timeout: request.timeout} : {}),
		...(request?.retry !== undefined ? {retry: request.retry} : {}),
	};
	if (!Object.keys(transport).length) return useApiBase(url, fetchOptions, options);

	let apiOptions = options;
	if ((options.cache === true || (options.cache === 'client' && import.meta.client)) && !options.dataKey && !options.key && !(fetchOptions?.body instanceof FormData)) {
		// Transport controls must not change the shared layer's existing cache key.
		apiOptions = {...options, dataKey: hash(['api-fetch', url, fetchOptions, useLang().get()])};
	}
	return useApiBase(url, {...transport, ...fetchOptions}, apiOptions);
}
